import React from 'react'
import { useCompetitionInsightsLogic } from './CompetitionInsights.logic'
import styles from './CompetitionInsights.module.scss'

export interface CompetitionInsightsProps {}

export const CompetitionInsights = ({ active }: any) => {
  return <div>CompetitionInsights</div>
}
